import { ca } from '@cian/analytics';

export enum EBlocks {
  Graphs = 'Graphs',
  PickUpProduct = 'PickUpProduct',
  Models = 'Models',
}

export function trackSwipe(label: EBlocks) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Swipe',
    label,
  });
}
